import { ref, nextTick } from 'vue'
import { replaceS3path } from '@/Shared/helper.js'

/**
 * プリロードを実行
 * @param {{
 * data: Object[],
 * key: String,
 * callback: Function,
 * }}
 * 以下の引数をオブジェクトに格納
 * @param data 元データ（例：props.newsItems.data, props.booksInfo.dataなど）
 * @param key 元データから画像を取得するキー（例：newsThumb, bookThumb, brandImg, shopImgなど）
 * @param callback コールバック関数
 */

export default function usePreloadImages({ data, key, callback }){

  const loadedImageNum = ref(0)

  const preloadImages = async() => {
    for (const item of data) {
      await loadImage(replaceS3path(item[key])).catch(e => {
        console.log('onload error', e)
      })
      updateloadedImageNum()
    }
  }
  
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = (e) => reject(e)
      img.src = src
    })
  }

  const updateloadedImageNum = () => {
    loadedImageNum.value++
    if (loadedImageNum.value === data.length) nextAction()
  }
  
  const nextAction = () => {
    if (typeof window === 'undefined') return
    nextTick(() => {
      window.requestAnimationFrame(() => {
        callback()
      })
    })
  }

  preloadImages()
}